module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-SJD.e2364f89.png";